module.exports = __webpack_public_path__ + "images/花筑奢pr长图_04-3.jpg?v=d59aed93";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_04-3.jpg
 ** module id = 32
 ** module chunks = 1 2
 **/